import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ZapIcon, FileTextIcon } from 'lucide-react';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.07
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 12
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4
    }
  }
};
export function WhatYouGet() {
  return <section className="bg-light py-20 md:py-32 px-5" data-id="element-336">
      <div className="max-w-2xl mx-auto" data-id="element-337">
        <motion.div className="text-center mb-14" initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-338">
          <div className="inline-flex items-center gap-2 text-xs font-display font-bold tracking-[0.15em] uppercase text-money-deep border border-money-deep/20 bg-money/5 rounded-full px-4 py-1.5 mb-5" data-id="element-339">
            <ZapIcon className="w-3.5 h-3.5" data-id="element-340" />
            PDF Práctico
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-dark leading-tight" data-id="element-341">
            Lo que <span className="text-gradient-money" data-id="element-342">recibes</span>
          </h2>
          <p className="font-sans text-dark/40 mt-3 text-sm" data-id="element-343">
            Todo esto por menos de lo que gastas en un berrinche en Target 🎯
          </p>
        </motion.div>

        {/* Book content */}
        <motion.div className="space-y-3 mb-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-344">
          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-345">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-346">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-347" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-348">
              <strong data-id="element-349">Configuración en 30 minutos</strong> — materiales, reglas
              y montos sugeridos por edad (5–7, 8–10, 11–14).
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-350">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-351">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-352" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-353">
              <strong data-id="element-354">3 opciones de reparto</strong> listas para elegir
              (50/40/10, 40/50/10, 60/30/10).
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-355">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-356">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-357" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-358">
              <strong data-id="element-359">Guion palabra por palabra</strong> de la Reunión de 7
              Minutos (cópialo tal cual).
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-360">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-361">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-362" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-363">
              Capítulos dedicados a cada jarra: <strong data-id="element-364">Gastar</strong> (lista
              de espera 48h), <strong data-id="element-365">Ahorrar</strong> (metas por edad +
              matching), <strong data-id="element-366">Dar</strong> (valores en acción).
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-367">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-368">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-369" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-370">
              <strong data-id="element-371">Protocolo anti-berrinche</strong> para tienda y Amazon (3
              frases + regla Wishlist).
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-372">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-373">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-374" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-375">
              <strong data-id="element-376">Consecuencias calmadas</strong> — qué hacer cuando rompen
              reglas (sin gritos, sin culpa).
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-377">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-378">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-379" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-380">
              <strong data-id="element-381">Plan de 30 días</strong> semana por semana con metas
              claras.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-382">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-383">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-384" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-385">
              <strong data-id="element-386">Guía para subir de nivel</strong> — dinero ganado, chores
              y negociación sana.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-387">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-388">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-389" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-390">
              <strong data-id="element-391">Plan de mantenimiento a 12 meses</strong> — cómo hacerlo
              "lo normal" en tu casa.
            </p>
          </motion.div>
        </motion.div>

        {/* Plantillas section */}
        <motion.div className="bg-money/5 border border-money/15 rounded-2xl p-6 md:p-8 mb-8" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} viewport={{
        once: true,
        margin: '-40px'
      }} data-id="element-392">
          <div className="flex items-center gap-3 mb-4" data-id="element-393">
            <div className="w-8 h-8 rounded-full bg-money/15 flex items-center justify-center" data-id="element-394">
              <FileTextIcon className="w-4 h-4 text-money" data-id="element-395" />
            </div>
            <h3 className="font-display text-lg font-bold text-dark" data-id="element-396">
              + Plantillas Incluidas
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 font-sans text-sm text-dark/70" data-id="element-397">
            <span data-id="element-398">📋 Poster "Reglas de dinero en esta casa"</span>
            <span data-id="element-399">⏳ Lista de espera 48h (con campos listos)</span>
            <span data-id="element-400">📝 Guion completo de la reunión semanal</span>
            <span data-id="element-401">🎯 Tablas de metas y montos por edad</span>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div className="text-center mt-10" initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} viewport={{
        once: true
      }} data-id="element-402">
          <a href="#precio" className="inline-block bg-gradient-to-r from-money-dark via-money to-emerald-400 text-white font-display font-bold text-base px-8 py-3.5 rounded-xl shadow-lg hover:scale-[1.03] active:scale-[0.98] transition-transform duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-money" data-id="element-403">
            Obtener Todo Esto →
          </a>
        </motion.div>
      </div>
    </section>;
}